import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/tributario/contribuinteservico/';

class ContribuinteServicoService {
    constructor() {
        this.idCliente = null;
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    findAllServicos(idContribuinte) {
        return axios.get(API_URL + 'all?idContribuinte='+idContribuinte, {headers: this.headers});
    }

    findAllNfAvulsa(filtro, idContribuinte) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        return axios.get(API_URL + 'allNfAvulsa?filtro='+filtro+'&idCliente='+this.idCliente+'&idContribuinte='+idContribuinte, {headers: this.headers}).then(response => (this.data = response.data));
    }

    findAllServicosByContribuinteFiltro(filtro, idContribuinte) {
        return axios.get(API_URL + 'filter?idContribuinte='+idContribuinte+'&filtro='+filtro, {headers: this.headers}).then(response => (this.data = response.data.elements));
    }

    getContribuinteServico(idServico) {
        let idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;
        return axios.get(API_URL + 'servico?idServico=' + idServico + '&idContribuinte=' + idContribuinte, { headers: this.headers });
    }
    
}

export default new ContribuinteServicoService();